import { memo } from 'react'

import walletNotifyBanner from 'assets/wallet-notify-banner.jpg'
import Notification from './Notification'

const WalletNotification = ({ ...restProps }) => {
  return (
    <Notification
      title='notification.level-up-status'
      desc='notification.level-up-status-desc'
      banner={walletNotifyBanner}
      noProviders
      {...restProps}
    />
  )
}

export default memo(WalletNotification)
